const getRequestObject = (filterOptions) => {
  return {
    // min: filterOptions.duration.min,
    // max: filterOptions.duration.max,
    instructors: extractFilterAttribute(filterOptions.instructors, 'slug'),
    styles: extractCategorySlugs(filterOptions.styles).concat(
      filterOptions?.yoga?.length > 0
        ? extractFilterAttribute(filterOptions?.yoga, 'slug')
        : [],
      filterOptions?.fitness?.length > 0
        ? extractFilterAttribute(filterOptions?.fitness, 'slug')
        : [],
      filterOptions?.mindfulness?.length > 0
        ? extractFilterAttribute(filterOptions?.mindfulness, 'slug')
        : [],
      filterOptions?.wellness?.length > 0
        ? extractFilterAttribute(filterOptions?.wellness, 'slug')
        : [],
      filterOptions?.skills?.length > 0
        ? extractFilterAttribute(filterOptions?.skills, 'slug')
        : []
    ),
    difficulties: filterOptions.difficulties,
    equipments: filterOptions.equipment,
    focus_areas: filterOptions.focus_area,
    excludeCompleted: filterOptions.excludeCompleted,
    intensities: extractFilterAttribute(filterOptions.intensities, 'level'),
    type: extractFilterAttribute(filterOptions.type, 'type'),
    duration: filterOptions.duration
  }
}

const extractCategorySlugs = (filteredCategories) => {
  const filtered = []
  for (const category in filteredCategories) {
    const filteredSubcategories =
      filteredCategories[category].filteredSubcategories || []
    if (filteredSubcategories === 'all') {
      filtered.push(category)
    } else {
      filteredSubcategories.forEach((subcategory) => {
        filtered.push(subcategory.slug)
      })
    }
  }
  return filtered
}

const extractFilterAttribute = (filteredObject, filterByField) =>
  filteredObject?.map((filter) => {
    if (typeof filter === 'object') {
      return filter[filterByField]
    } else {
      return filter
    }
  })

export { getRequestObject }
